import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import type { PeopleSearchResult, PeopleSearchStatus } from "@lib/logic";
import { Loader } from "@atoms";
import { useConnectBasePath } from "@hooks";
import { Avatar } from "@molecules";

import { HaNSearchResultCell } from "../../../../HereAndNowRevamp/search/components/HaNSearchResultCell";

type PeopleSearchResultsProps = {
  status: PeopleSearchStatus;
  results: PeopleSearchResult[];
};

export const PeopleSearchResults = ({ status, results }: PeopleSearchResultsProps) => {
  const { t } = useTranslation();
  const basePath = useConnectBasePath();

  if (status === "searching") {
    return (
      <div className="flex justify-center p-4">
        <Loader size="24px" />
      </div>
    );
  }

  if (status === "failed") {
    return <p className="p-4 text-mapiq-black-500">{t("connection:SearchPeopleFailed")}</p>;
  }

  if (results.length === 0) {
    return <p className="p-4 text-mapiq-black-500">{t("connection:NoPeopleFound")}</p>;
  }

  return (
    <ul className="overflow-y-auto py-2">
      {results.map(({ person, ranges }) => {
        return (
          <li key={person.id}>
            <Link
              to={`${basePath}/${person.id}`}
              className="flex px-4 py-3 font-normal text-inherit no-underline hover:bg-mapiq-black-50 hover:text-inherit hover:no-underline focus-visible:bg-mapiq-black-50 focus-visible:text-inherit focus-visible:no-underline focus-visible:outline-none">
              <HaNSearchResultCell
                icon={
                  <Avatar
                    className="flex-none"
                    size="large"
                    user={{
                      id: person.id,
                      email: person.email,
                      initials: person.initials ?? "",
                      name: person.name,
                      imageHash: person.imageHash,
                    }}
                  />
                }
                name={person.name}
                ranges={ranges}
                details={person.email}
              />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
